import axios from 'axios';
import { envConfig } from '../../../env';


// const source = 'https://servertest.cottongame.com/source'
const source = envConfig.formalServer + '/cotton';

// const cotton = 'https://server.cottongame.com/cotton'  // 正式服 serverstore
const cotton = envConfig.formalServer + "/cotton"


//--- AntiProjectData.vue
export const getAntiProjectDataPage = params => axios.post(source + '/getAntiProjectDataPage', params) // 获取防沉迷项目信息
export const postAntiProjectData = params => axios.post(source + '/postAntiProjectData', params, {     // 新增防沉迷项目信息
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
})
export const getProjectDataByObjectId = params => axios.post(source + '/getProjectDataByObjectId', params) // 获取待编辑防沉迷项目信息
export const updateAntiProjectData = params => axios.post(source + '/updateAntiProjectData', params, {     // 修改防沉迷项目信息
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
})
export const updateMultipleAntiProjectData = params => axios.post(source + '/updateMultipleAntiProjectData', params, {   // 批量修改防沉迷项目信息
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
})

//--- Players.vue
export const getPlayers = params => axios.post(cotton + '/getPlayers', params);  // 获取玩家信息
export const updatePlayerIdentity = params => axios.post(cotton + '/updatePlayerIdentity', params);  // 修改玩家
export const banPlayer = params => axios.post(cotton + '/banPlayer', params)    // 封禁玩家
export const unsealPlayer = params => axios.post(cotton + '/unsealPlayer', params)  // 解禁玩家
export const deletePlayerTest = params => axios.post(cotton + '/deletePlayerTest', params)  // 物理删除玩家信息


//--- AntiaddictionTest.vue
export const getAntiAddictionPage = params => axios.post(cotton + '/getAntiAddictionPage', params);     // 获取防沉迷白名单信息
